export const UPLOAD_INVENTORY_CSV_TEMPLATE_URL =
  'https://docs.google.com/spreadsheets/d/1gQPHqiVNpU2ju6AAJSLAxc6WLPEdxa0TkdFjd9q4Mbg/edit?usp=sharing';

export const UPLOAD_BUFFERS_CSV_TEMPLATE_URL =
  'https://docs.google.com/spreadsheets/d/1qffxv1NKNQuwufNkA8vbFU64DzwmqtLYOP6Pt0VwSb4/edit?gid=0#gid=0';
